import {useEffect, useState} from "react";
import {Button, Input, Table, Row} from "antd";
import {getPlantStrains} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";

export const StrainSelectWidget = ({strain, io, onSelect, defaultActive=true, props}) => {
    const [searchVal, setSearchVal] = useState("");
    const [options, setOptions] = useState([]);
    const [inventory, setInventory] = useState([]);
    const {onApiFail, refresh} = io;
    const [active, setActive] = useState(defaultActive);

    const updateOptions = (val, inventory) => {
        const searchData = inventory.filter(row => {
            return row.name.toLowerCase().includes(val.toLowerCase());
        })
        setOptions(searchData);
    }
    useEffect(() => {
        getPlantStrains().then((x) => {
            const tableData = x.map((val, index) => {
                return {...val, key: val.id}
            });

            setInventory(tableData);
        }).catch(e => {
            handleNoSession(e, onApiFail)
        });
    }, [refresh, onApiFail]);

    const selectStrain = (record) => () => {
        if (onSelect) {
            onSelect(record);
        }
        setActive(false);
    }


    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Select',
            dataIndex: 'id',
            key: 'select',
            render: (val, record) => {
                return <Button onClick={selectStrain(record)}>Select</Button>
            }
        }
    ]

    const onInputChange = (e) => {
        const val = e.target.value;
        setSearchVal(val);
        if (val.length >= 2) {
            updateOptions(val, inventory);
        } else {
            setOptions([])
        }
    }

    const onClick = () => {
        setActive(true);
    }

    const inputStyle = {
        width: 300
    }

    const rowStyle = {marginTop: '5px', marginBottom: '5px'}
    let placeholder = "Strain";

    if (active) {
        return <div>
            <Row style={rowStyle}>
                <Input style={inputStyle} placeholder={placeholder} value={searchVal} onChange={onInputChange}/>
            </Row>
            {(options.length > 0) &&
                <Table dataSource={options} columns={columns} pagination={false}/>
            }
        </div>
    } else {
        return <div onClick={onClick} style={{cursor: 'pointer', color: "#108ee9"}}>
            <Row style={rowStyle}>
            {(strain) ? strain.name: "Select Strain"}
            </Row>
        </div>
    }
}